"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _vue = _interopRequireDefault(require("vue"));

var _vuex = _interopRequireWildcard(require("vuex"));

var _authentication = require("./authentication");

var _common = require("./common");

var _lastMileDelivery = require("./last-mile-delivery");

var _lastMileDeliveryPricerite = require("./last-mile-delivery-pricerite");

var _lastMileDeliveryWellcome = require("./last-mile-delivery-wellcome");

var _lastMileV = require("./last-mile-v2");

var _milkRun = require("./milk-run");

var _milkRunV = require("./milk-run-v2");

var _railway = require("./railway");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var store = {
  strict: true,
  modules: {
    authentication: (0, _authentication.createAuthenticationModule)(),
    common: (0, _common.createCommonModule)(),
    lastMileDelivery: (0, _lastMileDelivery.createLastMileDeliveryModule)(),
    lastMileDeliveryPricerite: (0, _lastMileDeliveryPricerite.createLastMileDeliveryPriceriteModule)(),
    lastMileDeliveryWellcome: (0, _lastMileDeliveryWellcome.createLastMileDeliveryWellcomeModule)(),
    lastMileV2: (0, _lastMileV.createLastMileV2Module)(),
    milkRun: (0, _milkRun.createMilkRunModule)(),
    milkRunV2: (0, _milkRunV.createMilkRunV2Module)(),
    railway: (0, _railway.createRailwayModule)()
  }
};

function createStore() {
  var vueInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _vue.default;
  vueInstance.use(_vuex.default);
  return new _vuex.Store(store);
}